module.exports = {
  NODE_ENV: '"production"',
  CONFIG: {
    Env: 'production',
    Gateway: {
      host: 'gateway.opoli.com',
      port: 8081,
      url: 'https://gateway.opoli.com/',
      healthPath: '/'
    },
    d2dAPI: 'https://prodapi.door2dooranywhere.com',
    d2dGateway: 'https://gateway23.opoli.com',
    oldBackofficeLink: 'https://admin.opoli.com/',
    mediaHost: 'https://media.opoli.com',
    optimizationHost: 'https://opt.opoli.com',
    googleApiKey: 'AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA',
    Firebase: {
      apiKey: 'AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk',
      authDomain: 'opoli-production.firebaseapp.com',
      databaseURL: 'https://opoli-production.firebaseio.com',
      projectId: 'opoli-production',
      storageBucket: 'opoli-production.appspot.com"',
      messagingSenderId: '948692888036'
    },
    hereApi: {
      id: '0HVa2uc67AYd0cnqzAee',
      code: 'Ar6I-EINztpimEq5fnplQA',
      key: 'hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM'
    },
    featureToggle: {
      requiredDropoffAirport: false,
      militaryTime: true
    },
    brands: [
      {
        id: 2,
        code: 'op',
        trxCode: 'op',
        name: 'Opoli',
        url: 'https://www.opoli.com/'
      },
      {
        id: 3,
        code: 'gs',
        trxCode: 'gs',
        name: 'GoSedan',
        url: 'https://gosedan.com/'
      },
      {
        id: 4,
        code: 'pts',
        trxCode: 'pt',
        name: 'Prime Time Shuttle',
        url: 'https://www.primetimeshuttle.com/'
      },
      {
        id: 5,
        code: 's2l',
        trxCode: 'sa',
        name: 'Shuttle2LAX',
        url: 'https://www.shuttletolax.com/'
      },
      {
        id: 6,
        code: 'pts',
        trxCode: 'sv',
        name: 'Prime Time Shuttle',
        url: 'https://www.primetimeshuttle.com/'
      },
      {
        id: 7,
        code: 'fd',
        trxCode: 'fd',
        name: 'Fresh Deliveries',
        url: 'https://www.opoli.com/'
      },
      {
        id: 8,
        code: 'bh',
        trxCode: 'bh',
        name: 'BeverlyHilton',
        url: 'https://beverlyhilton.opoli.com/'
      },
      {
        id: 9,
        code: 'ms',
        trxCode: 'ms',
        name: 'Masimo',
        url: 'https://masimo.primetimeshuttle.com/'
      },
      {
        id: 10,
        code: 'd2d',
        trxCode: 'dd',
        name: 'Door2Door',
        url: 'https://door2doorflights.com/'
      },
      {
        id: 11,
        code: 'ip',
        trxCode: 'ip',
        name: 'IPW',
        url: 'https://ipw.opoli.com/'
      },
      {
        id: 12,
        code: 'ro',
        trxCode: 'ro',
        name: 'Roland',
        url: 'https://roland.opoli.com/'
      },
      {
        id: 13,
        code: 'gz',
        trxCode: 'gz',
        name: 'GozoCabs',
        url: 'https://usatravel.gozocabs.com/'
      },
      {
        id: 14,
        code: 'bdp',
        trxCode: 'bd',
        name: 'Bobby Dee Presents',
        url: 'https://bobbydeepresents.ridesharepro.com/'
      },
      {
        id: 15,
        code: 'ncp',
        trxCode: 'nc',
        name: 'NCP Mobility',
        url: 'https://www.opoli.com/'
      },
      {
        id: 16,
        code: 'LH',
        trxCode: 'pt',
        name: 'Langham Hotels',
        url: 'https://www.primetimeshuttle.com/'
      },
      {
        id: 17,
        code: 'bw',
        trxCode: 'pt',
        name: 'Best Western Hotels',
        url: 'https://www.primetimeshuttle.com/'
      },
      {
        id: 18,
        code: 'bb',
        trxCode: 'pt',
        name: 'Big Bus Tours',
        url: 'https://www.primetimeshuttle.com/'
      },
      {
        id: 19,
        code: 'rs',
        trxCode: 'rs',
        name: 'Prime Time Rideshare',
        url: 'https://www.primetimerideshare.com/'
      },
      {
        id: 20,
        code: 'pm',
        trxCode: 'pm',
        name: 'PMCAA',
        url: 'https://portal.primetimerideshare.com/pmcaa/'
      },
      {
        id: 21,
        code: 'fm',
        trxCode: 'fm',
        name: 'Fairmont',
        url: 'https://portal.primetimerideshare.com/fairmont/'
      },
    ],
    serviceId: {
      shared: 5,
      opoli: 4,
      black: 3,
      suv: 2,
      shuttle: 1,
      doorToDoor: 49
    },
    default: {
      brandId: 2,
      laxAirportId: 21,
      laxServiceAreaId: [29, 54, 69, 70, 81, 82, 104, 105, 106, 107, 108, 109, 110, 111, 112, 192, 218, 239, 240, 241, 244, 245, 246, 247, 258, 259, 383, 388, 389, 417, 424, 425, 427, 453, 455, 456, 457, 458, 459, 460, 461, 462, 511, 512, 513, 517, 518, 519, 520, 521, 522, 523, 524, 525, 526, 527, 574, 575]
    },
    useOldQuatation: false,
    Stripe: {
      paymentURL: 'https://dashboard.stripe.com/payments/',
      customerURL: 'https://dashboard.stripe.com/customers/',
      accountURL: 'https://dashboard.stripe.com/connect/accounts/',
      topupURL: 'https://dashboard.stripe.com/topups',
      transferURL: 'https://dashboard.stripe.com/connect/transfers',
      publishableKey: 'pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv',
    },
    socket: {
      asap: {
        host: 'wss://dispatch.opoli.com',
        protocol: 'echo-protocol'
      }
    },
    goResUserId: 219990,
    quickResUserId: 278079,
    specialUser: [
      {
        name: 'Flip Flip',
        id: 219990
      }
    ],
    lyftServiceIds: [201, 208, 215, 218, 216, 207, 203, 212, 206, 210, 217, 209, 205, 213, 211, 202, 204, 214]
  }
}



//////////////////
// WEBPACK FOOTER
// ./config/bundle/envs/production.js
// module id = 1799
// module chunks = 0